module.exports = __webpack_public_path__ + "img/index.36a719cf.png";